module.exports = __webpack_public_path__ + "img/vivo-gestao.3994349b.png";